import React from "react";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero__overlay">
        <div className="hero__content">
          <h1 className="hero__title">
            Boost Your Brand with <span>Powerful Ads</span> by <br /> AdsOn  <br />
            <span className="brand-name"> Digital Marketing Agency</span>
          </h1>

          <p className="hero__subtitle">
            Welcome to AdsOn Digital Marketing Agency! We help businesses 
            grow across <strong>all over UAE</strong> and <strong>globally</strong> 
            with expert advertising strategies, innovative campaigns, and data-driven results.
          </p>

          <div className="hero__buttons">
            <a href="#services" className="btn btn-primary">
              Explore Services
            </a>
            <a
              href="https://wa.me/971586567055"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline"
            >
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
